import React from "react";
import { FaMinus, FaTimes, FaCheck } from "react-icons/fa";

import { formatVariation, objectivePercent, objectiveRow } from "../btpSummary";

/* Les pourcentages et l'évaluation viennent de btpSummary.js — voir sa note
   d'en-tête pour la base de calcul (le projet standard) et les seuils. */
const ROWS = [
  { key: 'cbs', icon: "/icon/biodiversity.png", label: "Biodiversité", unit: "", better: 'higher' },
  { key: 'materiaux-waterfootprint', icon: "/icon/materiaux.png", label: "Matériaux", unit: "m³", better: 'lower' },
  { key: 'chantier-waterfootprint', icon: "/icon/chantier.png", label: "Chantier", unit: "m³", better: 'lower' },
  { key: 'exploitation-waterfootprint', icon: "/icon/exploitation.png", label: "Exploitation", unit: "m³", better: 'lower' },
];

const RATING_ICON = {
  reached: <FaCheck style={{ color: 'green', fontSize: '1.5em' }} title="Objectif atteint" />,
  partial: <FaMinus style={{ color: 'black', fontSize: '1.5em' }} title="Objectif partiellement atteint" />,
  missed: <FaTimes style={{ color: 'red', fontSize: '1.5em' }} title="Objectif non atteint" />,
};

const formatValue = (value) => {
  const formattedValue = value > 1 ? value.toFixed(0) : value.toFixed(2);
  return formattedValue.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
};

/* Le signe de la variation ne dit pas le progrès : −17 % en eau et +77 % en
   CBS sont deux bonnes nouvelles. La couleur, elle, suit l'amélioration. */
const improvementColor = (improvement) => {
  if (!improvement) return undefined;
  return improvement > 0 ? 'green' : 'red';
};

const ProjectScoreSummaryChart = ({ gameStatus }) => {
  const { score_dic } = gameStatus;

  const rows = ROWS.map((data) => ({ ...data, ...objectiveRow(score_dic[data.key], data.better) }));
  const percentageScore = objectivePercent(rows);

  return (
    <div className="pjs-graph-container">
      <div className="pjs-title">Vos résultats</div>
      <table className="pjs-graph-table">
        <thead>
          <tr>
            <th>Type</th>
            <th>Projet Aqua-cité</th>
            <th>Projet standard</th>
            <th>Variation</th>
            <th>Évaluation</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.key} className="pjs-graph-row">
              <td>
                <img className="water-footprint-icon" src={row.icon} alt={row.label} />
              </td>
              <td>{formatValue(row.value)} {row.unit}</td>
              <td>{formatValue(row.standard)} {row.unit}</td>
              <td style={{ fontWeight: 'bold', color: improvementColor(row.improvement) }}>{formatVariation(row.variation)}</td>
              <td>{RATING_ICON[row.rating]}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="pjs-score">
        Vous avez atteint <strong>{percentageScore}% de votre objectif !</strong>
      </div>
    </div>
  );
};

export default ProjectScoreSummaryChart;
